import { render, staticRenderFns } from "./AiAnswerDrawer.vue?vue&type=template&id=3c71da24&scoped=true&"
import script from "./AiAnswerDrawer.vue?vue&type=script&lang=js&"
export * from "./AiAnswerDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AiAnswerDrawer.vue?vue&type=style&index=0&id=3c71da24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71da24",
  null
  
)

export default component.exports